<i [class]="passwordValidations.minLengthCase ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>At least 9 characters</span>
<br>
<i [class]="passwordValidations.upperCase ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>At least one upper case letter</span>
<br>
<i [class]="passwordValidations.lowerCase ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden='true'></i>
<span>At least one lower case letter</span>
<br>
<i [class]="passwordValidations.numberCase ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>At least one number</span>
<br>
<i [class]="passwordValidations.specialCharacterCase ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>At least one special character (eg: !&#64;#$%^&*)</span>
<br>

@if(validateFirstAndLastName()){
<i [class]="passwordValidations.fName ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>Does not contain first name</span>
<br>
<i [class]="passwordValidations.lName ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>Does not contain last name</span>
<br>
}

@if (validateUsername()){
<i [class]="passwordValidations.uName ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>Does not contain part of username</span>
<br>
}

@if (validateDomain()){
<i [class]="passwordValidations.containsDomain ? 'fa fa-check validation-passed' : 'fa fa-check validation-failed'" aria-hidden="true"></i>
<span>Does not contain part of the domain</span>
}

